import React from 'react';

import { LayoutCard, Loading } from '../components';
import { useTeam } from '../hooks';
import TeamSection from '../Section/TeamSection';

const TeamCard = () => {
  const { teamUsers, isLoading } = useTeam();

  return (
    <LayoutCard
      title="Team"
      activeTabKey="people"
      tabList={[{ key: 'people', tab: 'People' }]}
      tabProps={{
        size: 'small',
      }}
      data-cy="dashboard-team-team-card"
    >
      {isLoading ? <Loading /> : <TeamSection teamUsers={teamUsers} />}
    </LayoutCard>
  );
};

export default TeamCard;
